import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  createDiagramItemFailed,
  createDiagramItemRequested,
  createDiagramItemSucceeded,
  deleteDiagramItemFailed,
  deleteDiagramItemRequested,
  deleteDiagramItemSucceeded,
  updateDiagramItemFailed,
  updateDiagramItemRequested,
  updateDiagramItemSucceeded,
} from '../../../actions';
import api from '../../../api';

export function* createDiagramItemRequest(data) {
  yield put(createDiagramItemRequested(data));

  try {
    const { item } = yield call(request, api.createDiagram, data);

    const action = createDiagramItemSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = createDiagramItemFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* updateDiagramItemRequest(id, data) {
  yield put(updateDiagramItemRequested(id, data));

  try {
    const { item } = yield call(request, api.updateDiagram, id, data);

    const action = updateDiagramItemSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = updateDiagramItemFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* deleteDiagramItemRequest(id) {
  yield put(deleteDiagramItemRequested(id));

  try {
    const { item } = yield call(request, api.deleteDiagram, id);

    const action = deleteDiagramItemSucceeded(item);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = deleteDiagramItemFailed(id, error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}
